import React, { useState } from 'react'
import { useAnnualPass } from '@mc/growth'
import { trackEmailCaptured } from '@mc/pre-paywall-events'
import { segment } from '@mc/track-event'
import { trackJoinEmailClick, trackComingSoonPurchaseClick } from '../events'
import { ComingSoonSignUp } from './ComingSoonSignUp'
import { JoinWaitListForm } from './JoinWaitListForm'
import classes from './ComingSoonEmailCapture.module.scss'

interface ComingSoonEmailCaptureProps {
  slug: string
}

export const ComingSoonEmailCapture = ({
  slug,
}: ComingSoonEmailCaptureProps) => {
  const [emailCaptured, setEmailCaptured] = useState(false)
  const annualPass = useAnnualPass()

  const onWaitListFormSubmit = ({ email }: { email: string }) => {
    trackJoinEmailClick(slug)

    trackEmailCaptured({
      event: segment.EventTypes.EMAIL_CAPTURED,
      properties: {
        type: 'email',
        category: 'hero',
        location: 'hero',
        email,
        page_type: 'class-page',
        class_type: 'camp',
        coming_soon_slug: slug,
      },
      integrations: { Iterable: true },
    })

    setEmailCaptured(true)
  }

  return (
    <div
      className={`${classes.emailCaptureContainer} mc-p-5 mc-corners--md mc-text--left`}
    >
      {emailCaptured ? (
        <ComingSoonSignUp
          onSubmit={(href) =>
            trackComingSoonPurchaseClick(slug, href, annualPass)
          }
        />
      ) : (
        <JoinWaitListForm onSubmit={onWaitListFormSubmit} />
      )}
    </div>
  )
}
